/* --------------------------------------------------------------------------------------
   xwTable.js
   Copyright © 2023 Xerox Corporation. All Rights Reserved.
     
   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
--------------------------------------------------------------------------------------*/

import { useRef, useEffect } from "preact/hooks"
import { MFDApp } from "../../constants/MFDApp.const"

const XwTable = props => {
	const elementRef = useRef(null)
	const elementId = `tbl-${new Date().getTime()}`
	useEffect(() => {
		$(elementRef.current).xrxtable(getOptions(props))
		return () => safeDestroy(elementRef)
	},[])
	return <table ref={elementRef} id={elementId}>
		{props.children}
	</table>
}

const getOptions = props => ({
	...props,
	theme: props.theme || MFDApp.theme,
	children: undefined
})

const safeDestroy = ref => {
    try {
        $(ref.current).xrxtable("destroy")
    } catch(e) {}
}

export default XwTable